export default __webpack_public_path__ + "static/media/Indrajeet Das.5e65d9ca.jpeg";